
import { defineComponent, computed } from "@vue/composition-api";
import { usePrices } from "@/hooks/use-prices";
import { useVuex } from "@/hooks/use-vuex";
import pkg from "../../package.json";

export default defineComponent({
  setup(_, ctx) {
    const { baseCurrency } = usePrices();
    const { store } = useVuex();
    const network = computed(() => store.state.Wallet.network);
    const settings = computed(() => store.state.Settings);

    const darkMode = computed({
      get: () => store.state.Settings.theme === "dark",
      set: () => store.dispatch.Settings.toggleTheme()
    });

    const expertMode = computed({
      get: () => store.state.Settings.mode === "expert",
      set: () => store.dispatch.Settings.toggleMode()
    });

    const toggleDarkMode = () => {
      store.dispatch.Settings.toggleTheme();
    };

    const toggleExpertMode = () => {
      store.dispatch.Settings.toggleMode();
    };

    const clear = async () => {
      const yes = await ctx.root.$dialog.confirm({
        title: "Are you sure?",
        text:
          "Do you really want to clear all app data including wallets and keys?"
      });
      if (yes) {
        localStorage.clear();
        location.reload();
      }
    };

    return {
      network,
      baseCurrency,
      darkMode,
      expertMode,
      toggleDarkMode,
      toggleExpertMode,
      pkg,
      clear,
      settings
    };
  }
});
